// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDGQrI85A4ghkR9yhxCLy5UjF2V3egyjtc",
  authDomain: "comicsreader-dcc40.firebaseapp.com",
  projectId: "comicsreader-dcc40",
  storageBucket: "comicsreader-dcc40.firebasestorage.app",
  messagingSenderId: "990589385453",
  appId: "1:990589385453:web:98820f166fed44c62aeae4",
  measurementId: "G-TC653DXV7H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
